import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { TOTAL_OPS } from '../../Utils/constant';
import { store } from '../../services/service';
import { useConfigStore } from '../../store/ConfigStore';

export const Configuration = ({ description, message, defaultValue }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [value, setValue] = useState();
    const totalOperations = useConfigStore()

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue])

    return (
        <>
            <div className="my-8 border bg-white w-fit rounded-xl">

                <div className="flex items-center gap-2 space-y-4 md:space-y-6 sm:p-8">

                    <div className='lg:flex items-center gap-4'>
                        <label className="font-mtn block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {description}
                        </label>
                        <input
                            onChange={(e) => setValue(e.target.value)}
                            defaultValue={defaultValue}
                            type="text"
                            className="input input-bordered text-gray-500 h-10 text-sm font-semibold"
                        />
                        <button
                            type="submit"
                            onClick={() => {
                                store(`${TOTAL_OPS}?totaleOp=${value}`, 'application/json', {}).then((res) => {
                                    if (res.status === 200) {
                                        toast.success(message)
                                        setIsSubmit(false)
                                        totalOperations.getData()
                                    }

                                }).catch((err) => {
                                    console.log(err);
                                    if (err.response.status === 500) {
                                        setIsSubmit(false)
                                        toast.error(err.response.data)
                                    }
                                })
                            }}
                            disabled={isSubmit ? true : false}
                            className={`${!isSubmit
                                ? "text-black bg-main"
                                : "text-slate-800 bg-slate-200 "
                                }  btn btn-sm`}
                        >
                            {!isSubmit ? "Appliquer" : "Veuillez patientez..."}{" "}
                            {isSubmit ? (
                                <span className="loading loading-dots loading-xs"></span>
                            ) : null}
                        </button>
                    </div>



                </div>
            </div>

        </>
    )
}
